<template>
  <div id="marketplace" class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 pt2 mb2">
      <div class="col-12 px0" v-if="showMobile">
        <div>
          <marketplace></marketplace>
        </div>
      </div>
      <div class="clearfix ml4" v-if="!showMobile">
        <div>
          <marketplace></marketplace>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import marketplace from './Marketplace'
import marketarchive from './MarketArchive'
// import hotlinemodal from './modals/HotlineModal'
import archivemodal from './modals/ArchiveModal'
import kundemodal from './modals/KundeModal'
// import Imentor from './imentor'
// import cards from './Cards'
export default {
  name: 'market',
  components: {
    // Imentor,
    marketarchive,
    marketplace,
    // cards,
    // hotlinemodal,
    archivemodal,
    kundemodal
  },
  mounted () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  data () {
    return {
      showMobile: false,
      items: ''
    }
  },
  methods: {
  }
}
</script>
<style>
.fa-shopping-cart {
  font-size: 26px;
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active, .list-leave-active {
  transition: all 300ms;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(200px);
}
.line-height-golden {
  line-height: 1.618;
}
button.close {
  padding: 15px;
}
.modal-header,
.modal-footer {
  border: 0;
}
.modal-title {
  font-size: 14px;
}
.card-img-overlay {
  padding: 0;
  border: 0;
}
.card-title {
  font-size: 12px;
  background: rgba(0,0,0,0.75);
  padding: 12px;
  position: absolute;
  bottom: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// Start.vue?c312d0c0